module.exports = __webpack_public_path__ + "static/img/Team 1.8249e48.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hr/Team 1.png
// module id = COta
// module chunks = 2